import { action, observable, makeAutoObservable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import wfTrackerService from "@services/workflow/wfTrackerService"
import { initMultiLanguageField } from "@lib/helper"

class WfTrackerStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }
  @action
  async create(createWfTrackerInput) {
    const result = await wfTrackerService.create(createWfTrackerInput)
    this.tableData.items.push(result)
  }

  @action
  async update(updateWfTrackerInput) {
    await wfTrackerService.update(updateWfTrackerInput)
    this.tableData.items = this.tableData.items.map((x) => {
      if (x.id === updateWfTrackerInput.id) x = updateWfTrackerInput
      return x
    })
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await wfTrackerService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id) {
    this.detailData = await wfTrackerService.get({ id })
  }

  @action
  async createWfTracker() {
    this.detailData = {
      id: 0,
      names: initMultiLanguageField(),
      isActive: true,
    }
  }

  @action
  async getAll(pagedFilterAndSortedRequest: any) {
    this.isLoading = true
    this.tableData = await wfTrackerService
      .filter(pagedFilterAndSortedRequest)
      .finally(() => (this.isLoading = false))
  }

  @action
  async updateSortList(ids: number[]) {
    await wfTrackerService.updateSortList(ids)
  }
}

export default WfTrackerStore
